"use client";

import { c as _c } from "react-compiler-runtime";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { persistTrackingQueryParams } from "../trackingPersistence/trackingPersistence";
export function TrackingQueryParamsBootstrap() {
  const $ = _c(3);
  const searchParams = useSearchParams();
  let t0;
  let t1;
  if ($[0] !== searchParams) {
    t0 = () => {
      persistTrackingQueryParams(searchParams);
    };
    t1 = [searchParams];
    $[0] = searchParams;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}